import cx from 'classnames';

import { useState } from 'react';
import { Sanity$CarouselImage } from '@otovo/shared/types/sanityImage';
import SanityImage from '@otovo/shared/components/Sanity/SanityImage';

type CarouselProps = {
  productImages: Sanity$CarouselImage[];
};
const ProductImageCarousel = ({ productImages }: CarouselProps) => {
  const [currentIndex, setCurrentIndex] = useState(0);

  const goToImage = (imageIndex: number) => {
    setCurrentIndex(imageIndex);
  };

  const goToNextImage = () => {
    const nextImageIndex = currentIndex + 1;

    if (nextImageIndex === productImages.length) {
      setCurrentIndex(0);
    } else {
      setCurrentIndex(nextImageIndex);
    }
  };

  return (
    <>
      <div className="m-auto flex h-[240px] max-w-full flex-col sm:h-[340px]">
        <SanityImage
          image={productImages[currentIndex].image}
          className="m-auto h-full max-h-full max-w-full object-cover"
          alt={productImages[currentIndex].alt}
          loading="lazy"
          sizes="(max-width: 767px) 239px, 519px"
          onClick={() => goToNextImage()}
        />
      </div>
      <div className="my-6 flex justify-center gap-6">
        {productImages.map((image, imageIndex) => {
          return (
            <button
              type="button"
              key={image.alt}
              onClick={() => goToImage(imageIndex)}
              aria-label={`Go to image ${imageIndex + 1}`}
              className="cursor-pointer text-2xl text-black"
            >
              <span
                className={cx(
                  'inline-block h-5 w-5 rounded-full',
                  'lg:h-4 lg:w-4',
                  `${
                    currentIndex === imageIndex ? 'bg-grey-40' : 'bg-grey-20'
                  }`,
                )}
              />
            </button>
          );
        })}
      </div>
    </>
  );
};

export default ProductImageCarousel;
